export default __webpack_public_path__ + "static/media/fastFood07.0bf5fca7.png";